// our root app component

import { Directive, ElementRef, HostListener, OnDestroy, OnInit, Renderer2 } from '@angular/core';
// import { NgControl } from '@angular/forms';

@Directive({
  selector: '[handleActive]',
})
export class HandleActiveDirective implements OnInit,OnDestroy {
  constructor(
    private renderer: Renderer2,
    private el: ElementRef,
    // private control: NgControl
    ) {}
  handle;
  public ngOnInit() {
    // if(this.el.nativeElement.value){
      this.updateClass();
    // }
    // this.handleActiveClass();
  }
  @HostListener('ngModelChange', ['$event'])
  onEvent($event) {
    this.updateClass();
  }
  // private handleActiveClass() {
  //   this.handle = this.control.valueChanges
  //     .subscribe((value: string) => {
  //       this.updateClass();
  //     });
  // }
  updateClass(){
    const event = this.el.nativeElement.value;
    if(event){
      this.renderer.addClass(this.el.nativeElement, 'active');
    }else{
      this.renderer.removeClass(this.el.nativeElement, 'active');
    }
  }
  ngOnDestroy(){
    // this.handle.unsubscribe();
  }
}
